import { getCSSVariableValue } from './css'

export const getHeaderHeight = () =>
    parseInt(getCSSVariableValue('header-height'))
